import React from 'react';

const Input = ({ label, type = 'text', name, value, className, onChange, placeholder, ...rest }) => {
  const safeValue = value == null ? '' : value;
  return (
    <div>
      {label && <label className={`block font-semibold mb-1 text-gray-800 dark:text-white ${className}`}>{label}</label>}
      <input
        type={type}
        name={name}
        value={safeValue}
        onChange={onChange}
        placeholder={placeholder}
        className={`w-full border rounded-md p-2 bg-white dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 ${className}`}
        {...rest} // Allows other input attributes to be passed
      />
    </div>
  );
};

export default Input;